export default "__VITE_ASSET__56abba36__"